import React from "react";
import {AdmissionFromSearch} from "../../../../../services/AdmissionsService";
import {AdmissionCardActionsMenu} from "../AdmissionCardActionsMenu";
import {EditPreflightDropdownItem} from "../EditPreflightDropdownItem";
import {ResendEmailDropdownItem} from "./ResendEmailDropdownItem";
import {DeleteAdmissionDropdownItem} from "../DeleteAdmissionDropdownItem";
import {ViewAdmissionDropdownItem} from "../ViewAdmissionDropdownItem";
import {DownloadPDFDropdownItem} from "../DownloadPDFDropdownItem";
import {DownloadArbitrationPDFDropdownItem} from "../DownloadArbitrationPDFDropdownItem";
import {ChangeHistoryDropdownItem} from "./ChangeHistoryDropdownItem";
import {ForceDeleteAdmissionDropdownItem} from "../ForceDeleteAdmissionDropdownItem";
import {getResidentTestId} from "../../../helper";

type Props = Readonly<{
  admission: AdmissionFromSearch;
}>;

export const InProgressSplitButton = ({admission}: Props) => (
  <AdmissionCardActionsMenu
    testId={getResidentTestId(admission, "inProgressCardActions")}
  >
    <EditPreflightDropdownItem admission={admission} />
    <ViewAdmissionDropdownItem admission={admission} />
    <ChangeHistoryDropdownItem admission={admission} />
    <ResendEmailDropdownItem admission={admission} />
    <DownloadPDFDropdownItem admission={admission} />
    <DownloadArbitrationPDFDropdownItem admission={admission} />
    <DeleteAdmissionDropdownItem admission={admission} />
    <ForceDeleteAdmissionDropdownItem admission={admission} />
  </AdmissionCardActionsMenu>
);
